module.exports = {
  "logo-alt": "PlanetCross File Exchange",
  "auth-planetx-about-title": "What is PlanetCross?",
  "auth-planetx-about-description":
    "PlanetCross enables secure, decentralized data exchange between organizations. It combines advanced solutions with proven technologies to ensure the integrity and security of data and files.",
  "auth-planetfx-about-title": "What is File Exchange?",
  "auth-planetfx-about-description":
    "PlanetCross File Exchange provides a secure, traceable, and user-friendly way to exchange files inside and outside of companies and organisations using Planetcross transport mechanism.",
  "auth-form-login-title": "Log in to Your Account",
  "auth-form-register-title": "Create Your Account",
  "auth-form-recover-title": "Forgotten your password?",
  "auth-form-login": "Login",
  "auth-form-register": "Register",
  "auth-form-continue": "Continue",
  "auth-form-recover-link": "Forgotten your password?",
  "auth-login-form-email-label": "Registered email address",
  "auth-login-form-email-placeholder": "Email Address",
  "auth-login-form-password-label": "Enter Password",
  "auth-login-form-password-placeholder": "Password",
  "auth-register-form-email-label": "Registered email address",
  "auth-register-form-email-placeholder": "Email Address",
  "auth-register-form-password-label": "Password",
  "auth-register-form-password-placeholder": "Password",
  "auth-form-register-password-strength-title": "Password Strength",
  "auth-form-register-password-strength-weak": "Weak",
  "auth-form-register-password-strength-medium": "Medium",
  "auth-form-register-password-strength-strong": "Strong",
  "dashboard-header-upload": "Upload",
  "dashboard-no-files": "No files to display",
  "dashboard-exchange-expired": "Expired",
  "dashboard-expires": "Expires",
  "dashboard-expires-days": "days",
  "dashboard-no-files-upload": "Click <a>upload</a> to start sharing files",
  "dashboard-files-incoming-title": "Incoming Files",
  "dashboard-files-outgoing-title": "Outgoing Files",
  "dashboard-files-outgoing-download": "Download Files",
  "dashboard-files-outgoing-share": "Send again",
  "dashboard-modal-drag-and-drop": "Drag files here<br>to upload",
  "dashboard-modal-cancel": "Cancel",
  "dashboard-modal-choose-files": "Choose Files",
  "dashboard-modal-upload-files": "Upload files",
  "dashboard-modal-share-files": "Send Files",
  "dashboard-modal-files-title": "Files",
  "dashboard-modal-share": "Send",
  "dashboard-modal-form-email-label": "People",
  "dashboard-modal-form-expires-label": "Expires",
  "dashboard-modal-form-at": "at",
  "dashboard-modal-form-on": "on",
  "dashboard-modal-form-hours": "hours",
  "dashboard-modal-form-days": "days",
  "dashboard-modal-emails-placeholder": "Type an email address...",
  "dashboard-modal-message-placeholder": "Type a message...",
  "dashboard-modal-validuntil-placeholder": "test",
  "dashboard-modal-incomplete-exchanges": "You have incomplete exchanges:",
  "dashboard-modal-invalid-email": "You have entered an invalid email address.",
  "dashboard-dropdown-account": "Your Account",
  "dashboard-dropdown-logout": "Logout",
  "dashboard-activity-title": "Activity",
  "dashboard-empty-activity": "There are no activities",
  "dashboard-activity-filter-all": "All",
  "dashboard-activity-filter-sent": "Sent",
  "dashboard-activity-filter-received": "Received",
  "modal-error-default-message": "Something went wrong",
  "modal-ok-button": "Ok",
  UNAUTHORIZED: "Your login session has expired. Please log in again.",
  INTERNAL_SERVER_ERROR:
    "The server encountered an internal error and was unable to complete your request. Please contact your system administrator.",
  ACCESS_DENIED: "Access is denied.",
  ENTITY_NOT_FOUND: "Entity not found",
  COULD_NOT_READ_FILE: "The file could not be accessed.",
  INVALID_EMAIL:
    "You have entered an invalid email address. Please check your details and try again",
  INVALID_EXPIRATION_DATE:
    "You have entered an invalid expiration date. Please check your details and try again.",
  EMAIL_NOT_REGISTERED:
    "The email address you inserted is not registered. Please check your details and try again.",
  DUPLICATE_RECIPIENT: "DUPLICATE_RECIPIENT",
  CANNOT_MODIFY_EXCHANGE: "CANNOT_MODIFY_EXCHANGE",
  EXCHANGE_ILLEGAL_STATUS: "EXCHANGE_ILLEGAL_STATUS",
  XCHANGE_XROAD_MEMBER_RESOLUTION_FAILED:
    "EXCHANGE_XROAD_MEMBER_RESOLUTION_FAILED",
  EXCHANGE_SERVICE_ERROR: "EXCHANGE_SERVICE_ERROR",
  EXCHANGE_NO_RECIPIENTS: "Recipient not Found.",
  EXCHANGE_NO_SENDER: "Sender not found.",
  EXCHANGE_NO_SUCH_RECEIVER: "Receiver not found.",
  EXCHANGE_NO_FILES: "EXCHANGE_NO_FILES",
  EXCHANGE_EXPIRED: "EXCHANGE_EXPIRED",
  EXCHANGE_DUPLICATE: "EXCHANGE_DUPLICATE",
  "dashboard-files": "files",
  "dashboard-shared-with": "Send to",
  "auth-verification-modal-title": "Verify Your Account",
  "auth-verification-modal-text":
    "A verification email has been sent to the address you provided. Please follow the link inside the email to verify your account and start using PlanetCross File Exchange.",
  "auth-verification-modal-back": "Back to Login",
  "auth-verification-complete-modal-title": "Verification Complete",
  "auth-back-to-login": "Go to Login Screen",
  "auth-verification-complete-modal-text":
    "Thank you for verifying your email address. Registration is complete and you can now log in using the email address and password you supplied during the registration process.",
  "auth-form-invalid": "Your email or password is incorrect. Please try again",
  "confirm-delete": "Confirm Delete",
  "confirm-incoming-modal-delete":
    "Deleting this record will remove all files permanently from your list. The other addresses can still access the files. <br><br> Are you sure you want to continue?",
  "confirm-outgoing-modal-delete":
    "Deleting this record will also delete the files from the list of every addressee. This cannot be undone. <br><br> Are you sure you want to continue?",
  "auth-form-recover": "Send Email",
  "auth-form-recover-description":
    "Enter you registered email address and we’ll send you an email containing a link to change your password.",
  "email-sent": "Email Sent",
  "recover-email-content":
    "An email containing a link to change your password has been sent to your regsitered email address.",
  "auth-new-password": "New Password",
  "auth-confirm-new-password": "Confirm Password",
  "auth-change-password-description":
    "Change your password for account with registered email {email}",
  "auth-update-password": "Update Password",
  "auth-password-changed": "Password Changed",
  "auth-password-changed-description":
    "You can now log in using your registered email address and updated password from the login screen.",
  "auth-verification-failed": "Verification Failed",
  "auth-verification-failed-description":
    "The verification link has expired, please register again.",
  "auth-go-to-registration": "Go to Registration Screen",
  DOMAIN_NOT_REGISTERED:
    "This email address is not eligible for registration on this domain",
  "auth-reset-password": "Reset password",
  "password-protect": "Password protect",
  "whats-this": "what’s this?",
  "password-protect-tooltip":
    "Check this box to password-protect your file(s). The password will be automatically generated by the system and provided to recipient(s) in the exchange email notice.",
  "upload-modal-add-files": "Add files",
  "upload-modal-add-files-description": "Drag more files here or click:",
  "user-profile-password-changed": "Your password was changed successfully",
  "user-profile-title": "Your account",
  "back-to-dashboard": "Back to Dashboard",
  "profile-account-details": "Account Details",
  "profile-registered-email": "Registered Email Address",
  "profile-change-password": "Change Password",
  "profile-current-password": "Current Password",
  "file-not-available":
    "The file you are trying to download was not found. The link you followed may be outdated or inaccurate.",
  FIRST_LOGIN: "Welcome to PlanetCross File Exchange!",
  OUTGOING_NEW:
    "You sent {count} files to <span title='{receiverFullEmail}'>{receiver}</span> {otherReceivers}",
  OUTGOING_DELETED_BY_SENDER:
    "You deleted {count} file sent to <span title='{receiverFullEmail}'>{receiver}</span> {otherReceivers}",
  INCOMING_NEW:
    "{count} files received from <span title='{senderFullEmail}'>{senderName}</span>",
  INCOMING_DELETED_BY_RECEIVER:
    "You deleted {count} files from <span title='{senderFullEmail}'>{senderName}</span>.",
  INCOMING_DELETED_BY_SENDER:
    "{count} files from <span title='{senderFullEmail}'>{senderName}</span> was deleted by <span title='{senderFullEmail}'>{senderName}</span>",
  INCOMING_EXPIRED:
    "{count} files from <span title='{senderFullEmail}'>{senderName}</span> has expired",
  INCOMING_EXPIRED_AND_DELETED:
    "{count} files from <span title='{senderFullEmail}'>{senderName}</span> has expired and deleted automatically",
  "activity-other-receivers":
    "<span title='{fullEmails}'>and {count} others</span>",
  "dashboard-other-receivers-tooltip":
    "and <strong class='tooltip' tooltip-title='{otherReceivers}'>{count} others</strong>",
  XROAD_MEMBER_RESOLUTION_FAILED: "You entered an invalid email address.",
  PASSWORD_MISMATCH: "Your current password is incorrect.",
  "date-picker-format": "dd/MM/yyyy",
  loading: "Loading...",
  "exchange-file-upload-failed": "Upload failed",
  EXCHANGE_MAX_TOTAL_SIZE_EXCEEDED:
    "The file(s) could not be uploaded because the maximum total file size limit is exceeded.",
  "dashboard-incoming-exchange-received":
    "<strong>{count} files</strong> received from <strong>{sender}</strong>",
  "dashboard-outgoing-exchange-sent":
    "You sent <strong>{count} files</strong> to <strong>{receiver}</strong> {outgoingOtherReceivers}",
  "entity-too-large": "This file can not be uploaded because it is too large.",
  "is-not-registered": " is not registered"
};
